// extracted by mini-css-extract-plugin
export default {"container":"Eo-z","heading":"Fo-z","text":"Go-z","info":"Ho-z","link":"Io-z","fullMaxWidth":"Jo-z"};